import React from 'react';
import './index.less';

export const WTitle = ({ title }: { title: string }) => (
  <h1 className="w-title">{title}</h1>
);
export const CTitle = ({ title }: { title: string }) => (
  <h2 className="c-title">{title}</h2>
);
export const STitle = ({ title }: { title: string }) => (
  <h1 className="s-title">{title}</h1>
);
export const TTitle = ({ title }: { title: string }) => (
  <h1 className="t-title">{title}</h1>
);
export const LeftIcon = ({ fill = '#A8A8A8' }: { fill: string }) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_b_641_1798)">
      <path
        d="M-1.30118e-08 24C-2.0198e-08 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 -5.82557e-09 10.7452 -1.30118e-08 24Z"
        fill={fill}
      />
    </g>
    <path
      d="M12.9019 25.0655C12.5114 24.675 12.5114 24.0418 12.9019 23.6513L19.2659 17.2873C19.6564 16.8968 20.2896 16.8968 20.6801 17.2873C21.0706 17.6779 21.0706 18.311 20.6801 18.7015L15.0232 24.3584L20.6801 30.0153C21.0706 30.4058 21.0706 31.0389 20.6801 31.4295C20.2896 31.82 19.6564 31.82 19.2659 31.4295L12.9019 25.0655ZM35.1016 25.3584L13.609 25.3584L13.609 23.3584L35.1016 23.3584L35.1016 25.3584Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_b_641_1798"
        x="-4"
        y="-4"
        width="56"
        height="56"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="2" />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_641_1798"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_641_1798"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export const RightIcon = ({ fill = '#A8A8A8' }: { fill: string }) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_b_641_1795)">
      <circle
        cx="24"
        cy="24"
        r="24"
        transform="matrix(1 -8.76943e-08 -8.71521e-08 -1 0 48)"
        fill={fill}
      />
    </g>
    <path
      d="M35.0981 22.9345C35.4886 23.325 35.4886 23.9582 35.0981 24.3487L28.7341 30.7127C28.3436 31.1032 27.7104 31.1032 27.3199 30.7127C26.9294 30.3221 26.9294 29.689 27.3199 29.2985L32.9768 23.6416L27.3199 17.9847C26.9294 17.5942 26.9294 16.9611 27.3199 16.5705C27.7104 16.18 28.3436 16.18 28.7341 16.5705L35.0981 22.9345ZM12.8984 22.6416L34.391 22.6416L34.391 24.6416L12.8984 24.6416L12.8984 22.6416Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_b_641_1795"
        x="-4"
        y="-4"
        width="56"
        height="56"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="2" />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_641_1795"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_641_1795"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export const CompleteIcon = ({ fill = '#0B54A1' }: { fill: string }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="7" cy="7" r="7" fill={fill} />
    <path
      d="M6.33333 10L4 7.87234L4.81667 7.12766L6.33333 8.51064L10.1833 5L11 5.74468L6.33333 10Z"
      fill="white"
    />
  </svg>
);
export const ProgressIcon = ({ fill = '#F76D25' }: { fill: string }) => (
  <svg
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="7.33008" cy="7" r="6.5" stroke={fill} />
    <path
      d="M7.33008 12C6.004 12 4.73223 11.4732 3.79454 10.5355C2.85686 9.59785 2.33008 8.32608 2.33008 7C2.33008 5.67392 2.85686 4.40215 3.79454 3.46447C4.73223 2.52678 6.004 2 7.33008 2V7V12Z"
      fill={fill}
    />
  </svg>
);
